import type { ReactNode } from 'react';
import { Panel } from '../ui/Panel';
import AccountLockNotice from './AccountLockNotice';

export interface GuestLockedPageProps {
    title: string;
    children: ReactNode;
}

/** Stands in for a page guest accounts can't use (issue #332), with a way to create an account. */
export default function GuestLockedPage({ title, children }: GuestLockedPageProps) {
    return (
        <main className="max-w-3xl mx-auto p-4 flex flex-col gap-4">
            <Panel variant="solid" padding="md" className="flex flex-col gap-4">
                <h2 className="text-display text-content-primary">{title}</h2>
                <AccountLockNotice showCreateAccount data-testid="guest-locked-page">
                    {children}
                </AccountLockNotice>
            </Panel>
        </main>
    );
}
